import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import { PublicController } from "../../ajax/PublicController";
import { FundDetailsDTO } from "../../ajax/types/FundDetailsDTO";
import { ImageGallerieComponent } from "../components/image-gallerie/ImageGallerieComponent";
import { LoadingComponent, date, FormFieldComponent } from "jsl-ui";
import { statusNames } from "../constants";
import { UserNameComponent } from "../components/UserNameComponent";
import { isInRole } from "../../helper/ajax";
import Axios from "axios";
import { CopyrightComponent } from "../components/CopyrightComponent";

export class StatusComponent implements IJSLComponent {

    private data: FundDetailsDTO;
    private copyrightComp: CopyrightComponent;

    private loading = false;


    constructor(private id: number) {
        this.copyrightComp = new CopyrightComponent();
        PublicController.GetFund({ id }).then((data) => {
            this.data = data;
            refresh();
        });
    }

    public render(): IJSLVNode {
        if (this.data == null) {
            return <section class="banner-area">{new LoadingComponent()}</section>;
        }
        return <section class="banner-area">
            <div class="col-md-12" style="text-align:center">
                <div style="text-align:left;">
                    <a class="genric-btn primary" href="#upload">zurück</a>
                </div>
                <h2>Fund Status</h2>
                <p>Taxa: {this.data.name}</p>
                <p>Status: {statusNames[this.data.status]}</p>
                {this.data.freigabeKommentar ?
                    <p>Bemerkung: {this.data.freigabeKommentar}</p> : null}
                {this.data.freigegebenVon ?
                    <p>Geprüft von: {new UserNameComponent(this.data.freigegebenVon)}</p> : null}
                {this.data.freigegebenAm ?
                    <p>Geprüft am: {date.format(this.data.freigegebenAm)}</p> : null}
                {new ImageGallerieComponent(this.data.images)}


                {(this.data.erstelltVon?.toLowerCase() === (window as any)._user?.toLowerCase() || isInRole("admin")) ? <div>
                    <h3>
                        Weitere Bilder hochladen
                        </h3>
                    <div>
                        <input type="file" multiple />
                        {this.copyrightComp}
                        <button class="genric-btn" style={this.loading ? "visibility:hidden" : ""}
                            click={(evt, node) => { this.uploadImages(node.dom.parentElement.querySelector("input"), this.data.fundId); }}>
                            hochladen</button> {this.loading ? new LoadingComponent() : null}
                        <p>&nbsp;</p>
                    </div>
                </div> : null}
            </div>
        </section>;
    }

    private uploadImages(el: HTMLInputElement, fundId: number) {
        const files = el.files;
        if (files.length > 0) {
            this.loading = true;
            const imgformData = new FormData();
            for (let i = 0; i < files.length; i++) {
                imgformData.append("files", files[i]);
            }

            Axios.post("api/expert/uploadimages?fundId=" + fundId +
                "&copy=" + encodeURIComponent(this.copyrightComp.getValue() ?? ""), imgformData, {}).then(() => {
                    location.reload();
                }).catch((e) => {
                    this.loading = false;
                    alert("error: " + e.response.data.title);
                    refresh();
                });
        }
    }

}
